import React from 'react';
import { FormatPrice } from 'utils/format';

const AmountCell = ({ currency, value }) => {
  if (value === null || value === undefined) {
    return null;
  }
  return (
    <>
      <FormatPrice currency={currency} value={value} />
    </>
  );
};

export default AmountCell;
